import './common'
import '../scss/style.scss';

import '~components/range-slider/range-slider'
import '~components/filter/filter'
import '~components/slider/slider'
import '~components/forms/select/select'
import '~components/j-fav/j-fav'
import '~components/prices/prices'

